import DocumentsPage from "../features/documents/DocumentsPage";

export default function DocumentsRoute() {
  return <DocumentsPage />;
}
